import 'swiper/css';
import 'swiper/css/pagination';
import { HashNavigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import Step1Android from '../../assets/target/images/step1Android.png';
import Step1Ios from '../../assets/target/images/step1Ios.png';
import Step2Android from '../../assets/target/images/step2Android.png';
import Step2Ios from '../../assets/target/images/step2Ios.png';
import Step3Android from '../../assets/target/images/step3Android.png';
import Step3Ios from '../../assets/target/images/step3Ios.png';
import Step4Android from '../../assets/target/images/step4Adnroid.png';
import Step4Ios from '../../assets/target/images/step4Ios.png';
import PageHeader from '../../components/PageHeader';

import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Button from '../../components/Button';
import './AddCardToWallet.scss';

const AddCardToWallet = () => {
	const swiperRef = useRef(null);
	const [isLastSlide, setIsLastSlide] = useState(false);
	const [imagesReady, setImagesReady] = useState(false);
	const [osName, setOsName] = useState(null);
	const [searchParams] = useSearchParams();
	// const osName = searchParams.get('operationSystem');
	const navigate = useNavigate();

	useEffect(() => {
		const os = searchParams.get('operationSystem');
		setOsName(os);
	}, []);

	const APPLE_WALLET = [
		{
			id: 1,
			img: Step1Ios,
			step: 'Step 1',
			title: 'Open Apple Wallet',
			subtitle: 'Open Apple Wallet on your iPhone and tap "+" to add a new card.',
		},
		{
			id: 2,
			img: Step2Ios,
			step: 'Step 2',
			title: 'Choose to add a card',
			subtitle: 'In Wallet, select the option to add a debit or credit card.',
		},
		{
			id: 3,
			img: Step3Ios,
			step: 'Step 3',
			title: 'Confirm card adding',
			subtitle: "Follow Apple's instructions to confirm adding the card to your Wallet.",
		},
		{
			id: 4,
			img: Step4Ios,
			step: 'Step 4',
			title: 'Done - card added',
			subtitle: 'Your card has been successfully added to Apple Wallet and is ready to use.',
		},
	];
	const GOOGLE_WALLET = [
		{
			id: 1,
			img: Step1Android,
			step: 'Step 1',
			title: 'Add card to Google Wallet',
			subtitle: 'Open Google Wallet and tap "Add to Wallet" to start adding your card.',
		},
		{
			id: 2,
			img: Step2Android,
			step: 'Step 2',
			title: 'Choose payment card',
			subtitle: 'Select Payment card from the list of available options.',
		},
		{
			id: 3,
			img: Step3Android,
			step: 'Step 3',
			title: 'Enter card details',
			subtitle: 'Enter your card number, expiration date, and security code to continue.',
		},
		{
			id: 4,
			img: Step4Android,
			step: 'Step 4',
			title: 'Card added successfully',
			subtitle: 'Your card is now added to Google Wallet and ready to use for payments',
		},
	];

	const handleNextClick = () => {
		if (!swiperRef.current) return;

		if (isLastSlide) {
			navigate(-1);
		} else {
			swiperRef.current.slideNext();
		}
	};

	const SlideItem = ({ item }) => {
		return (
			<div className='SlideItem'>
				<img src={item.img} loading='eager' decoding='sync' />
				<div>
					<p className='SlideItem__step'>{item.step}</p>
					<p className='SlideItem__title'>{item.title}</p>
					<p className='SlideItem__subtitle'>{item.subtitle}</p>
				</div>
			</div>
		);
	};

	const swiperItems = osName === 'iOS' ? APPLE_WALLET : GOOGLE_WALLET;

	return (
		<div className='AddCardToWallet'>
			<PageHeader />
			<div className='AddCardToWallet__swiper_content'>
				<Swiper
					onSwiper={swiper => {
						swiperRef.current = swiper;
						setIsLastSlide(swiper.isEnd);
					}}
					onSlideChange={swiper => {
						setIsLastSlide(swiper.isEnd);
					}}
					hashNavigation={{ watchState: true, replaceState: true }}
					modules={[HashNavigation, Pagination]}
					pagination={{
						dynamicBullets: true,
						dynamicMainBullets: 4,
						el: '.AddCardToWallet__swiper-pagination',
					}}
					touchReleaseOnEdges={true}
				>
					{swiperItems.map(item => (
						<SwiperSlide data-hash={item.id}>
							<SlideItem item={item} />
						</SwiperSlide>
					))}
				</Swiper>
			</div>
			<div className='AddCardToWallet__footer'>
				<div className='AddCardToWallet__swiper-pagination'></div>
				<Button
					styleType={isLastSlide ? 'primary' : 'secondary'}
					className='AddCardToWallet__button'
					onClick={handleNextClick}
				>
					{isLastSlide ? 'Done' : 'Next'}
				</Button>
			</div>
		</div>
	);
};

export default AddCardToWallet;
